/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Movie: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="movie" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3333333333333 1190C1195.6666666666667 1190 1246.6666666666665 1139 1246.6666666666665 1076.6666666666667V510C1246.6666666666665 447.6666666666667 1195.6666666666667 396.6666666666668 1133.3333333333333 396.6666666666668H736.6666666666666V283.3333333333335H963.3333333333331V170H396.6666666666667V283.3333333333335H623.3333333333333V396.6666666666668H113.3333333333333V1076.6666666666667C113.3333333333333 1139 164.3333333333333 1190 226.6666666666667 1190H1133.3333333333333zM226.6666666666667 510H1133.3333333333333V1076.6666666666667H226.6666666666667V510zM868.87 793.3333333333334L566.6666666666666 604.4633333333334V982.2033333333334L868.87 793.3333333333334z" : "M906.6666666666669 952C956.5333333333334 952 997.3333333333334 911.2 997.3333333333334 861.3333333333333V408C997.3333333333334 358.1333333333332 956.5333333333334 317.3333333333333 906.6666666666669 317.3333333333333H589.3333333333334V226.6666666666667H770.6666666666667V136H317.3333333333334V226.6666666666667H498.6666666666667V317.3333333333333H90.6666666666667V861.3333333333333C90.6666666666667 911.2 131.4666666666667 952 181.3333333333334 952H906.6666666666669zM181.3333333333334 408H906.6666666666669V861.3333333333333H181.3333333333334V408zM695.096 634.6666666666666L453.3333333333334 483.5706666666666V785.7626666666666L695.096 634.6666666666666z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Movie.displayName = `Blueprint5.Icon.Movie`;
export default Movie;
